import { fetchWithToken } from '@vizit/auth';
import { API_BASE_URL } from '@vizit/constants';

/**
 * Performs a multipart/form-data POST request with authentication
 *
 * @param path - The API path (without base URL)
 * @param file - The file or blob to upload
 * @param pathParams - Path parameters to replace in the URL
 * @returns The response data
 */
export async function multipartPost<T>(
  path: string,
  file: Blob | File,
  pathParams?: Record<string, string>,
): Promise<T> {
  let url = `${API_BASE_URL}${path}`;

  // Replace path parameters
  if (pathParams) {
    for (const [key, value] of Object.entries(pathParams)) {
      url = url.replace(`{${key}}`, encodeURIComponent(value));
    }
  }

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetchWithToken(url, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${errorText}`);
  }

  return response.json();
}
